import React, { useEffect, useState } from "react";
import { ReactTitle } from "react-meta-tags";

import { getRoles } from "../../../../Redux/reducer/session";
import { getProviderModules } from "../../../../Redux/actions/providerActions";
import {
  getModules,
  getOneProvider,
} from "../../../../Redux/reducer/providers";
import { useDispatch, useSelector } from "react-redux";
import Services from ".";
import Modal from "../../../utils/customModal";
import { loadingHtml } from "../../../utils/functions";
import { useParams } from "react-router";

const permissions = {
  default: [
    { value: 0, label: "0" },
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
  ],
  noApprovals: ["MOD_INVITATION_PROV", "MOD_LOG"],
};

const ProviderServices = () => {
  const [contentReady, setContentReady] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    onClose: undefined,
    content: null,
  });

  const { companyId, id } = useParams();

  const { roles, provider, modules } = useSelector((state) => ({
    provider: getOneProvider(state),
    modules: getModules(state),
    roles: getRoles(state),
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    fecthModules();
  }, []);

  const fecthModules = () => {
    setModal({ ...modal, show: true, content: loadingHtml() });
    return dispatch(getProviderModules(provider.id)).then(() => {
      setContentReady(true);
      setModal({ ...modal, show: false, content: null });
    });
  };

  return (
    <>
      <ReactTitle title={`Gestión de Proveedores - Servicios`} />
      {contentReady && (
        <Services
          modulo={modules}
          roles={roles}
          createUrl={`providers/modules/${companyId}/${id}`}
          createMethod={`put`}
          permissions={permissions}
          getModules={fecthModules}
        />
      )}
      <Modal
        key={`provider-users`}
        show={modal.show}
        handleClose={modal.onClose}
      >
        {modal.content}
      </Modal>
    </>
  );
};

export default ProviderServices;
